import LazyLoad from "react-lazyload"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const Robotics = () => {
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },

        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" },
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-hands-on-studio.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Facilities" breadEnd="Learning Approach" breadMid="Hands On Studio Lab" />
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-xl-12 mb-4">
                            <h4 className="color-red">Hands On Studio</h4>
                            <div class="lab-heading mb-4">
                                <div class="lab-btn" id="mb-lab-btn"><span>Labs</span></div>
                                <ul class="labs-list">
                                    <li><a class="" href="/mathmatics">Mathematics</a></li>
                                    <li><a class="" href="/physics">Physics</a></li>
                                    <li><a class="" href="/biology">Biology</a></li>
                                    <li><a class="" href="/chemistry">Chemistry</a></li>
                                    <li><a class="" href="/language">Language</a></li>
                                    <li><a class="" href="/computer">Computer</a></li>
                                    <li><a class="" href="/robotics">Robotics</a></li>
                                    <li><a class="inc-tlink-active" href="/hands-on-studio">Hands On Studio</a></li>
                                    <li><a class="" href="/psychology">Psychology</a></li>
                                    <li><a class="" href="/counseling-sen">Counseling &amp; Sen </a></li>
                                </ul>
                            </div>
                            <h5 className="text-center color-red">“ Tell me and I forget, teach me and I may remember, involve me and I learn.”</h5>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/handsonstudio1.jpg" className="float-end wid-500 m-2" alt="Lotus Valley Gurgaon" /></LazyLoad>
                            <p>Hands-on activities rekindle a love for learning and connect abstract concepts to the real world -- while achieving desired educational outcomes. Hands-on learning is an experiential learning technique that helps the learners gain understanding of concepts through direct medium of learning. When the learners study the concepts through hands-on learning, they build a functional understanding and develop the ability to become independent.</p>
                            <p>We at Lotus Valley International School, Gurgaon believe in personalized support and specialized resources to get our learners engaged in experiential learning. A hands-on learning environment has been provided to our learners in our State of the Art- ‘Hands-on Studio’. The activities held in the Hands-on Studio are designed to achieve the holistic development of the learners in terms of their language, listening, cognitive, fine motor and gross motor skills. The learners are encouraged to learn through various medium such as -audio -visual, tactile, kinesthetic as well as social.</p>
                            <p className="mb-4">The wide array of activities that our learners are involved in at the Hands- on Studio range from vocabulary building, reading, sorting, sequencing and matching, puzzles, blocks building, missing numbers, theatre to treasure hunt and many more.</p>
                            <h5 className="text-center color-red">PEEP INTO HANDS-ON STUDIO</h5>
                            <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/handonstudio2.jpg" className="float-end wid-500 m-2" alt="Lotus Valley Gurgaon" /></LazyLoad>
                            <ul className="admission-list">
                                <li>Feed the Bear- In this fun alphabets based activity learners are guided to feed the fish shape alphabets in the Bear’s mouth.</li>
                                <li>Story telling- Old Mac Donald farm game was taken up to introduce the learners the theme of farm animals.</li>
                                <li>Puppet Show- Learners were excited to watch and enact the puppet show through the theatre window on Children’s Day.</li>
                                <li>Number matching Cookie Jar- The recognition and quantification of numbers was well learnt with this number activity.</li>
                                <li>Tracing Lines- The learners were introduced pre-writing skills through this interesting activity.</li>
                                <li>Collage of Lord Krishna- During Govindastami the learners decorated the sketch of Lord Krishna with crayon shavings.</li>
                                <li>What comes after- Learners indicated and placed the numbers on the boogie to understand the concept of before and after.</li>
                                <li>Dance on Colours- The concept of colours was reinforced with this movement based activity.</li>
                            </ul>
                        </div>

                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Robotics